import type React from "react";

import { faGripVertical } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import styled from "styled-components";

interface DragHandleProps {
  isDisabled?: boolean;
}

export const DragHandle: React.FC<DragHandleProps> = ({ isDisabled }) => {
  return (
    <Container className={clsx({ disabled: isDisabled })}>
      <FontAwesomeIcon icon={faGripVertical} fontSize="14px" />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.redesign.db50};
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  &.disabled {
    color: ${({ theme }) => theme.colors.redesign.db30};
    cursor: not-allowed;
  }
`;
